export default __webpack_public_path__ + "static/media/consultation.56a0fcbd.png";